import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import ReceivableSummary from "./ReceivableSummary";

export default {
    storageKey: StorageKey.report_aging_summary_payable,
    getReportLabel: () => t`Aged Payables Summary`,
    required: [
        'legal_name',
        'base_coming_due_amount',
        'base_total_amount',
    ],
    getColumns: ReceivableSummary.getColumns,
};
